import { HOST } from '../config';
import { apiGet, apiPost, apiDelete, CancelToken } from '../api';

import { encodeId } from '../helpers';
import { toast } from 'react-toastify';

export const A = {
  REQUEST_GET_ITEMS: 'REQUEST_GET_ITEMS',
  RECEIVE_GET_ITEMS: 'RECEIVE_GET_ITEMS',
  ERROR_GET_ITEMS: 'ERROR_GET_ITEMS',

  REQUEST_GET_ITEM_BY_ID: 'REQUEST_GET_ITEM_BY_ID',
  RECEIVE_GET_ITEM_BY_ID: 'RECEIVE_GET_ITEM_BY_ID',
  ERROR_GET_ITEM_BY_ID: 'ERROR_GET_ITEM_BY_ID',

  REQUEST_ADD_ITEM: 'REQUEST_ADD_ITEM',
  RECEIVE_ADD_ITEM: 'RECEIVE_ADD_ITEM',
  ERROR_ADD_ITEM: 'ERROR_ADD_ITEM',

  REQUEST_EDIT_ITEM: 'REQUEST_EDIT_ITEM',
  RECEIVE_EDIT_ITEM: 'RECEIVE_EDIT_ITEM',
  ERROR_EDIT_ITEM: 'ERROR_EDIT_ITEM',

  REQUEST_COPY_ITEM: 'REQUEST_COPY_ITEM',
  RECEIVE_COPY_ITEM: 'RECEIVE_COPY_ITEM',
  ERROR_COPY_ITEM: 'ERROR_COPY_ITEM',

  REQUEST_ADD_IMAGE: 'REQUEST_ADD_IMAGE',
  RECEIVE_ADD_IMAGE: 'RECEIVE_ADD_IMAGE',
  ERROR_ADD_IMAGE: 'ERROR_ADD_IMAGE',

  REQUEST_REORDER_IMAGE: 'REQUEST_REORDER_IMAGE',
  RECEIVE_REORDER_IMAGE: 'RECEIVE_REORDER_IMAGE',
  ERROR_REORDER_IMAGE: 'ERROR_REORDER_IMAGE',

  REQUEST_DELETE_IMAGE: 'REQUEST_DELETE_IMAGE',
  RECEIVE_DELETE_IMAGE: 'RECEIVE_DELETE_IMAGE',
  ERROR_DELETE_IMAGE: 'ERROR_DELETE_IMAGE',

  REQUEST_GENERATE_VARIANTS: 'REQUEST_GENERATE_VARIANTS',
  RECEIVE_GENERATE_VARIANTS: 'RECEIVE_GENERATE_VARIANTS',
  ERROR_GENERATE_VARIANTS: 'ERROR_GENERATE_VARIANTS',

  REQUEST_EDIT_VARIANT: 'REQUEST_EDIT_VARIANT',
  RECEIVE_EDIT_VARIANT: 'RECEIVE_EDIT_VARIANT',
  ERROR_EDIT_VARIANT: 'ERROR_EDIT_VARIANT',

  REQUEST_DELETE_VARIANT: 'REQUEST_DELETE_VARIANT',
  RECEIVE_DELETE_VARIANT: 'RECEIVE_DELETE_VARIANT',
  ERROR_DELETE_VARIANT: 'ERROR_DELETE_VARIANT',

  REQUEST_HIDESHOW_ITEM: 'REQUEST_HIDESHOW_ITEM',
  RECEIVE_HIDESHOW_ITEM: 'RECEIVE_HIDESHOW_ITEM',
  ERROR_HIDESHOW_ITEM: 'ERROR_HIDESHOW_ITEM',

  REQUEST_ARCHIVE_ITEM: 'REQUEST_ARCHIVE_ITEM',
  RECEIVE_ARCHIVE_ITEM: 'RECEIVE_ARCHIVE_ITEM',
  ERROR_ARCHIVE_ITEM: 'ERROR_ARCHIVE_ITEM',

  REQUEST_RESTORE_ITEM: 'REQUEST_RESTORE_ITEM',
  RECEIVE_RESTORE_ITEM: 'RECEIVE_RESTORE_ITEM',
  ERROR_RESTORE_ITEM: 'ERROR_RESTORE_ITEM',

  REQUEST_GET_FEATURES: 'REQUEST_GET_FEATURES',
  RECEIVE_GET_FEATURES: 'RECEIVE_GET_FEATURES',
  ERROR_GET_FEATURES: 'ERROR_GET_FEATURES',

  REQUEST_ADD_FEATURE: 'REQUEST_ADD_FEATURE',
  RECEIVE_ADD_FEATURE: 'RECEIVE_ADD_FEATURE',
  ERROR_ADD_FEATURE: 'ERROR_ADD_FEATURE',

  REQUEST_GET_ATTRIBUTES: 'REQUEST_GET_ATTRIBUTES',
  RECEIVE_GET_ATTRIBUTES: 'RECEIVE_GET_ATTRIBUTES',
  ERROR_GET_ATTRIBUTES: 'ERROR_GET_ATTRIBUTES',

  REQUEST_ADD_ATTRIBUTE: 'REQUEST_ADD_ATTRIBUTE',
  RECEIVE_ADD_ATTRIBUTE: 'RECEIVE_ADD_ATTRIBUTE',
  ERROR_ADD_ATTRIBUTE: 'ERROR_ADD_ATTRIBUTE',

  REQUEST_GET_ACCOUNTING_ATTRIBUTES: 'REQUEST_GET_ACCOUNTING_ATTRIBUTES',
  RECEIVE_GET_ACCOUNTING_ATTRIBUTES: 'RECEIVE_GET_ACCOUNTING_ATTRIBUTES',
  ERROR_GET_ACCOUNTING_ATTRIBUTES: 'ERROR_GET_ACCOUNTING_ATTRIBUTES',

  REQUEST_ADD_ACCOUNTING_ATTRIBUTE: 'REQUEST_ADD_ACCOUNTING_ATTRIBUTE',
  RECEIVE_ADD_ACCOUNTING_ATTRIBUTE: 'RECEIVE_ADD_ACCOUNTING_ATTRIBUTE',
  ERROR_ADD_ACCOUNTING_ATTRIBUTE: 'ERROR_ADD_ACCOUNTING_ATTRIBUTE',

  REQUEST_GET_ADDITIONAL_DESCS: 'REQUEST_GET_ADDITIONAL_DESCS',
  RECEIVE_GET_ADDITIONAL_DESCS: 'RECEIVE_GET_ADDITIONAL_DESCS',
  ERROR_GET_ADDITIONAL_DESCS: 'ERROR_GET_ADDITIONAL_DESCS',

  REQUEST_EXPORT_ITEMS_TO_FULFILLMENT: 'REQUEST_EXPORT_ITEMS_TO_FULFILLMENT',
  RECEIVE_EXPORT_ITEMS_TO_FULFILLMENT: 'RECEIVE_EXPORT_ITEMS_TO_FULFILLMENT',
  ERROR_EXPORT_ITEMS_TO_FULFILLMENT: 'ERROR_EXPORT_ITEMS_TO_FULFILLMENT',

  REQUEST_GET_PRODUCT_APPEARANCE: 'REQUEST_GET_PRODUCT_APPEARANCE',
  RECEIVE_GET_PRODUCT_APPEARANCE: 'RECEIVE_GET_PRODUCT_APPEARANCE',
  ERROR_GET_PRODUCT_APPEARANCE: 'ERROR_GET_PRODUCT_APPEARANCE',

  REQUEST_UPDATE_PRODUCT_APPEARANCE: 'REQUEST_UPDATE_PRODUCT_APPEARANCE',
  RECEIVE_UPDATE_PRODUCT_APPEARANCE: 'RECEIVE_UPDATE_PRODUCT_APPEARANCE',
  ERROR_UPDATE_PRODUCT_APPEARANCE: 'ERROR_UPDATE_PRODUCT_APPEARANCE',

  REQUEST_GET_PRODUCT_REVIEWS: 'REQUEST_GET_PRODUCT_REVIEWS',
  RECEIVE_GET_PRODUCT_REVIEWS: 'RECEIVE_GET_PRODUCT_REVIEWS',
  ERROR_GET_PRODUCT_REVIEWS: 'ERROR_GET_PRODUCT_REVIEWS',

  REQUEST_UPDATE_PRODUCT_REVIEW: 'REQUEST_UPDATE_PRODUCT_REVIEW',
  RECEIVE_UPDATE_PRODUCT_REVIEW: 'RECEIVE_UPDATE_PRODUCT_REVIEW',
  ERROR_UPDATE_PRODUCT_REVIEW: 'ERROR_UPDATE_PRODUCT_REVIEW',

  REQUEST_GET_SUBSCRIPTION_DATA: 'REQUEST_GET_SUBSCRIPTION_DATA',
  RECEIVE_GET_SUBSCRIPTION_DATA: 'RECEIVE_GET_SUBSCRIPTION_DATA',
  ERROR_GET_SUBSCRIPTION_DATA: 'ERROR_GET_SUBSCRIPTION_DATA',

  REQUEST_IMPORT_SUBSCRIPTION_DATA: 'REQUEST_IMPORT_SUBSCRIPTION_DATA',
  RECEIVE_IMPORT_SUBSCRIPTION_DATA: 'RECEIVE_IMPORT_SUBSCRIPTION_DATA',
  ERROR_IMPORT_SUBSCRIPTION_DATA: 'ERROR_IMPORT_SUBSCRIPTION_DATA',

  REQUEST_GET_SKU_SETS: 'REQUEST_GET_SKU_SETS',
  RECEIVE_GET_SKU_SETS: 'RECEIVE_GET_SKU_SETS',
  ERROR_GET_SKU_SETS: 'ERROR_GET_SKU_SETS',

  REQUEST_UPDATE_SKU_SET: 'REQUEST_UPDATE_SKU_SET',
  RECEIVE_UPDATE_SKU_SET: 'RECEIVE_UPDATE_SKU_SET',
  ERROR_UPDATE_SKU_SET: 'ERROR_UPDATE_SKU_SET',

  REQUEST_GET_PHYSICAL_SET_ORDERS: 'REQUEST_GET_PHYSICAL_SET_ORDERS',
  RECEIVE_GET_PHYSICAL_SET_ORDERS: 'RECEIVE_GET_PHYSICAL_SET_ORDERS',
  ERROR_GET_PHYSICAL_SET_ORDERS: 'ERROR_GET_PHYSICAL_SET_ORDERS',

  REQUEST_UPDATE_PHYSICAL_SET_ORDER: 'REQUEST_UPDATE_PHYSICAL_SET_ORDER',
  RECEIVE_UPDATE_PHYSICAL_SET_ORDER: 'RECEIVE_UPDATE_PHYSICAL_SET_ORDER',
  ERROR_UPDATE_PHYSICAL_SET_ORDER: 'ERROR_UPDATE_PHYSICAL_SET_ORDER',

  REQUEST_COPY_PHYSICAL_SET_ORDER: 'REQUEST_COPY_PHYSICAL_SET_ORDER',
  RECEIVE_COPY_PHYSICAL_SET_ORDER: 'RECEIVE_COPY_PHYSICAL_SET_ORDER',
  ERROR_COPY_PHYSICAL_SET_ORDER: 'ERROR_COPY_PHYSICAL_SET_ORDER',

  REQUEST_CANCEL_PHYSICAL_SET_ORDER: 'REQUEST_CANCEL_PHYSICAL_SET_ORDER',
  RECEIVE_CANCEL_PHYSICAL_SET_ORDER: 'RECEIVE_CANCEL_PHYSICAL_SET_ORDER',
  ERROR_CANCEL_PHYSICAL_SET_ORDER: 'ERROR_CANCEL_PHYSICAL_SET_ORDER',

  REQUEST_GET_ESHOPS: 'REQUEST_GET_ESHOPS',
  RECEIVE_GET_ESHOPS: 'RECEIVE_GET_ESHOPS',
  ERROR_GET_ESHOPS: 'ERROR_GET_ESHOPS',

  REQUEST_GET_PRODUCTS_HISTORY: 'REQUEST_GET_PRODUCTS_HISTORY',
  RECEIVE_GET_PRODUCTS_HISTORY: 'RECEIVE_GET_PRODUCTS_HISTORY',
  ERROR_GET_PRODUCTS_HISTORY: 'ERROR_GET_PRODUCTS_HISTORY',

  REQUEST_PRODUCTS_HISTORY_DIFF: 'REQUEST_PRODUCTS_HISTORY_DIFF',
  RECEIVE_PRODUCTS_HISTORY_DIFF: 'RECEIVE_PRODUCTS_HISTORY_DIFF',
  ERROR_PRODUCTS_HISTORY_DIFF: 'ERROR_PRODUCTS_HISTORY_DIFF',

  REQUEST_PRODUCTS_BATCH_ACCOUNTING_STOCKS: 'REQUEST_PRODUCTS_BATCH_ACCOUNTING_STOCKS',
  RECEIVE_PRODUCTS_BATCH_ACCOUNTING_STOCKS: 'RECEIVE_PRODUCTS_BATCH_ACCOUNTING_STOCKS',
  ERROR_PRODUCTS_BATCH_ACCOUNTING_STOCKS: 'ERROR_PRODUCTS_BATCH_ACCOUNTING_STOCKS',

  REQUEST_PRODUCTS_WAREHOUSE_CATEGORIES: 'REQUEST_PRODUCTS_WAREHOUSE_CATEGORIES',
  RECEIVE_PRODUCTS_WAREHOUSE_CATEGORIES: 'RECEIVE_PRODUCTS_WAREHOUSE_CATEGORIES',
  ERROR_PRODUCTS_WAREHOUSE_CATEGORIES: 'ERROR_PRODUCTS_WAREHOUSE_CATEGORIES',

  REQUEST_GET_PRODUCTS_PRICE_MARGIN_HISTORY: 'REQUEST_GET_PRODUCTS_PRICE_MARGIN_HISTORY',
  RECEIVE_GET_PRODUCTS_PRICE_MARGIN_HISTORY: 'RECEIVE_GET_PRODUCTS_PRICE_MARGIN_HISTORY',
  RESET_GET_PRODUCT_PRICE_MARGIN_HISTORY: 'RESET_GET_PRODUCT_PRICE_MARGIN_HISTORY',
  ERROR_GET_PRODUCTS_PRICE_MARGIN_HISTORY: 'ERROR_GET_PRODUCTS_PRICE_MARGIN_HISTORY',

  REQUEST_GET_PRODUCT_MARGIN: 'REQUEST_GET_PRODUCT_MARGIN',
  RECEIVE_GET_PRODUCT_MARGIN_DELIVERED: 'RECEIVE_GET_PRODUCT_MARGIN_DELIVERED',
  RECEIVE_GET_PRODUCT_MARGIN_SHIPPED: 'RECEIVE_GET_PRODUCT_MARGIN_SHIPPED',
  RESET_GET_PRODUCT_MARGIN: 'RESET_GET_PRODUCT_MARGIN',
  ERROR_GET_PRODUCT_MARGIN: 'ERROR_GET_PRODUCT_MARGIN',

  REQUEST_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL: 'REQUEST_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL',
  RECEIVE_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL: 'RECEIVE_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL',
  ERROR_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL: 'ERROR_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL',

  REQUEST_STATISTICS_OF_USING_CHESTNYZNAK: 'REQUEST_STATISTICS_OF_USING_CHESTNYZNAK',
  RECEIVE_STATISTICS_OF_USING_CHESTNYZNAK: 'RECEIVE_STATISTICS_OF_USING_CHESTNYZNAK',
  ERROR_STATISTICS_OF_USING_CHESTNYZNAK: 'ERROR_STATISTICS_OF_USING_CHESTNYZNAK',

  REQUEST_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK: 'REQUEST_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK',
  RECEIVE_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK: 'RECEIVE_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK',
  ERROR_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK: 'ERROR_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK',

  REQUEST_GET_STOCK_BY_DATE: 'REQUEST_GET_STOCK_BY_DATE',
  RECEIVE_GET_STOCK_BY_DATE: 'RECEIVE_GET_STOCK_BY_DATE',
  ERROR_GET_STOCK_BY_DATE: 'ERROR_GET_STOCK_BY_DATE',

  REQUEST_POST_EXPORT_SKU: 'REQUEST_POST_EXPORT_SKU',
  RECEIVE_POST_EXPORT_SKU: 'RECEIVE_POST_EXPORT_SKU',
  ERROR_POST_EXPORT_SKU: 'ERROR_POST_EXPORT_SKU',

  REQUEST_GET_COMMON_MATERIAL: 'REQUEST_GET_COMMON_MATERIAL',
  RECEIVE_GET_COMMON_MATERIAL: 'RECEIVE_GET_COMMON_MATERIAL',
  ERROR_GET_COMMON_MATERIAL: 'ERROR_GET_COMMON_MATERIAL',

  REQUEST_GET_PACKAGING_SHIPMENT_REPORT: 'REQUEST_GET_PACKAGING_SHIPMENT_REPORT',
  RECEIVE_GET_PACKAGING_SHIPMENT_REPORT: 'RECEIVE_GET_PACKAGING_SHIPMENT_REPORT',
  ERROR_GET_PACKAGING_SHIPMENT_REPORT: 'ERROR_GET_PACKAGING_SHIPMENT_REPORT',

  TOGGLE_MONOBOXES_VISIBILITY: 'TOGGLE_MONOBOXES_VISIBILITY',

  REQUEST_UPLOAD_STICKERS_PALLET_EXCEL: 'REQUEST_UPLOAD_STICKERS_PALLET_EXCEL',
  RECEIVE_UPLOAD_STICKERS_PALLET_EXCEL: 'RECEIVE_UPLOAD_STICKERS_PALLET_EXCEL',
  ERROR_UPLOAD_STICKERS_PALLET_EXCEL: 'ERROR_UPLOAD_STICKERS_PALLET_EXCEL',
};

export const fetchGetItems = ({ size, barcode, type, search, order, page, deleted }) => {
  let url = `${HOST}/api/lite/products?size=${size}`;
  if (search) url += `&query=${search}`;
  if (barcode) url += `&barcode=${barcode}`;
  if (type) url += `&filters=SKU_TYPE:${type}`;
  if (order) url += `&order=${order}`;
  if (page) url += `&page=${page}`;
  if (deleted) url += `&deleted=true`;
  url += `&show_packages=true`; //! Удалить

  return (dispatch, getState) => {
    fetchGetItemsCancel();
    dispatch(requestGetItems());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        cancelToken: new CancelToken(function (cancel) {
          fetchGetItemsCancel = cancel;
        }),
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetItems(res.products));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetItems(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetItems(err));
          reject(err);
        },
      });
    });
  };
};

let fetchGetItemsCancel = () => null;

const requestGetItems = () => {
  return {
    type: A.REQUEST_GET_ITEMS,
  };
};

const receiveGetItems = (data) => {
  return {
    type: A.RECEIVE_GET_ITEMS,
    data,
  };
};

const errorGetItems = (err) => {
  return {
    type: A.ERROR_GET_ITEMS,
    err,
  };
};

export const fetchGetItemById = (productId, isArchived) => {
  let url = HOST + '/api/lite/products?id=' + encodeId(productId);
  if (isArchived) url += '&deleted=true';
  url += '&show_packages=true'; //Показывать инфу про монокороба в variants

  return (dispatch, getState) => {
    dispatch(requestGetItemById());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            const product = res.products[0];
            dispatch(receiveGetItemById(product));
            resolve(product);
          } else {
            const error = { data: { errors: res.errors } };
            dispatch(errorGetItemById(error));
            reject(error);
          }
        },
        error: (err) => {
          dispatch(errorGetItemById(err));
        },
      });
    });
  };
};

const requestGetItemById = () => {
  return {
    type: A.REQUEST_GET_ITEM_BY_ID,
  };
};

const receiveGetItemById = (data) => {
  return {
    type: A.RECEIVE_GET_ITEM_BY_ID,
    data,
  };
};

const errorGetItemById = (err) => {
  return {
    type: A.ERROR_GET_ITEM_BY_ID,
    err,
  };
};

export const fetchAddItem = ({ newProduct, singleVariant }) => {
  return (dispatch, getState) => {
    dispatch(requestAddItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products',
        tokens: getState().auth.tokenData,
        body: newProduct,
        callback: async (res) => {
          if (res.success) {
            const productId = res.id;
            await dispatch(receiveAddItem(res));
            const product = await dispatch(fetchGetItemById(productId));
            let variantErrors = null;
            if (product?.variants && product?.variants?.length) {
              await dispatch(
                fetchEditVariant({
                  ...singleVariant,
                  productId,
                  variantId: product.variants[0].id,
                }),
              ).catch((err) => {
                variantErrors = err;
              });
            }
            const result = await dispatch(fetchGetItemById(productId));
            resolve({ result, variantErrors });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddItem = () => {
  return {
    type: A.REQUEST_ADD_ITEM,
  };
};

const receiveAddItem = (data) => {
  return {
    type: A.RECEIVE_ADD_ITEM,
    data,
  };
};

const errorAddItem = (err) => {
  return {
    type: A.ERROR_ADD_ITEM,
    err,
  };
};

export const fetchEditItem = ({ product }) => {
  return (dispatch, getState) => {
    dispatch(requestEditItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products',
        tokens: getState().auth.tokenData,
        body: product,
        callback: async (res) => {
          if (res.success) {
            if (res?.variantsResult?.[0]?.errors?.[0]?.message) {
              toast.error(res.variantsResult[0].errors[0].message);
              return;
            }

            await dispatch(receiveEditItem(res));
            const result = await dispatch(fetchGetItemById(product.id, product.deleted)).catch(
              (err) => {
                reject(err);
              },
            );
            resolve({ ...result, variantsResult: res.variantsResult });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEditItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEditItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestEditItem = () => {
  return {
    type: A.REQUEST_EDIT_ITEM,
  };
};

const receiveEditItem = (data) => {
  return {
    type: A.RECEIVE_EDIT_ITEM,
    data,
  };
};

const errorEditItem = (err) => {
  return {
    type: A.ERROR_EDIT_ITEM,
    err,
  };
};

export const fetchCopyItem = (data) => {
  return (dispatch, getState) => {
    dispatch(requestCopyItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/copy',
        tokens: getState().auth.tokenData,
        body: data,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveCopyItem(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCopyItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCopyItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestCopyItem = () => {
  return {
    type: A.REQUEST_COPY_ITEM,
  };
};

const receiveCopyItem = (data) => {
  return {
    type: A.RECEIVE_COPY_ITEM,
    data,
  };
};

const errorCopyItem = (err) => {
  return {
    type: A.ERROR_COPY_ITEM,
    err,
  };
};

export const fetchDeleteVariant = (productId, variantId) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteVariant());
    return new Promise((resolve, reject) => {
      apiDelete({
        url:
          HOST + '/api/lite/products/variants?productId=' + productId + '&variantId=' + variantId,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteVariant(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteVariant(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteVariant(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteVariant = () => {
  return {
    type: A.REQUEST_DELETE_VARIANT,
  };
};

const receiveDeleteVariant = (data) => {
  return {
    type: A.RECEIVE_DELETE_VARIANT,
    data,
  };
};

const errorDeleteVariant = (err) => {
  return {
    type: A.ERROR_DELETE_VARIANT,
    err,
  };
};

export const fetchAddImage = (newImage) => {
  const formData = new FormData();
  Object.keys(newImage).forEach((key) => {
    formData.append(key, newImage[key]);
  });
  return (dispatch, getState) => {
    dispatch(requestAddImage());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/image',
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddImage(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddImage(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddImage(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddImage = () => {
  return {
    type: A.REQUEST_ADD_IMAGE,
  };
};

const receiveAddImage = (data) => {
  return {
    type: A.RECEIVE_ADD_IMAGE,
    data,
  };
};

const errorAddImage = (err) => {
  return {
    type: A.ERROR_ADD_IMAGE,
    err,
  };
};

export const fetchReorderImage = (data) => {
  return (dispatch, getState) => {
    dispatch(requestReorderImage());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/image/pos',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveReorderImage(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorReorderImage(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorReorderImage(err));
          reject(err);
        },
      });
    });
  };
};

const requestReorderImage = () => {
  return {
    type: A.REQUEST_REORDER_IMAGE,
  };
};

const receiveReorderImage = (data) => {
  return {
    type: A.RECEIVE_REORDER_IMAGE,
    data,
  };
};

const errorReorderImage = (err) => {
  return {
    type: A.ERROR_REORDER_IMAGE,
    err,
  };
};

export const fetchDeleteImage = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteImage());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/products/image?id=' + id,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteImage(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteImage(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteImage(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteImage = () => {
  return {
    type: A.REQUEST_DELETE_IMAGE,
  };
};

const receiveDeleteImage = (data) => {
  return {
    type: A.RECEIVE_DELETE_IMAGE,
    data,
  };
};

const errorDeleteImage = (err) => {
  return {
    type: A.ERROR_DELETE_IMAGE,
    err,
  };
};

export const fetchGenerateVariants = ({ productId, options }) => {
  return (dispatch, getState) => {
    dispatch(requestGenerateVariants());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/variants/generator',
        tokens: getState().auth.tokenData,
        body: { productId, options },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGenerateVariants(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGenerateVariants(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGenerateVariants(err));
          reject(err);
        },
      });
    });
  };
};

const requestGenerateVariants = () => {
  return {
    type: A.REQUEST_GENERATE_VARIANTS,
  };
};

const receiveGenerateVariants = (data) => {
  return {
    type: A.RECEIVE_GENERATE_VARIANTS,
    data,
  };
};

const errorGenerateVariants = (err) => {
  return {
    type: A.ERROR_GENERATE_VARIANTS,
    err,
  };
};

export const fetchEditVariant = (data) => {
  return (dispatch, getState) => {
    dispatch(requestEditVariant());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/variants',
        tokens: getState().auth.tokenData,
        body: data,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveEditVariant(res));
            const product = await dispatch(fetchGetItemById(data.productId, data.isArchived));
            resolve({ variantId: res.variantId, product });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEditVariant(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEditVariant(err));
          reject(err);
        },
      });
    });
  };
};

const requestEditVariant = () => {
  return {
    type: A.REQUEST_EDIT_VARIANT,
  };
};

const receiveEditVariant = (data) => {
  return {
    type: A.RECEIVE_EDIT_VARIANT,
    data,
  };
};

const errorEditVariant = (err) => {
  return {
    type: A.ERROR_EDIT_VARIANT,
    err,
  };
};

export const fetchArchiveItem = (item) => {
  return (dispatch, getState) => {
    dispatch(requestArchiveItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products',
        tokens: getState().auth.tokenData,
        body: Object.assign({}, item, { deleted: true }),
        callback: (res) => {
          if (res.success) {
            dispatch(receiveArchiveItem({ item }));
            resolve(res.product);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorArchiveItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorArchiveItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestArchiveItem = () => {
  return {
    type: A.REQUEST_ARCHIVE_ITEM,
  };
};

const receiveArchiveItem = (data) => {
  return {
    type: A.RECEIVE_ARCHIVE_ITEM,
    data,
  };
};

const errorArchiveItem = (err) => {
  return {
    type: A.ERROR_ARCHIVE_ITEM,
    err,
  };
};

export const fetchRestoreItem = (item) => {
  return (dispatch, getState) => {
    dispatch(requestRestoreItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products',
        tokens: getState().auth.tokenData,
        body: Object.assign({}, item, { deleted: false }),
        callback: (res) => {
          if (res.success) {
            dispatch(receiveRestoreItem({ item }));
            resolve(res.product);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRestoreItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRestoreItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestRestoreItem = () => {
  return {
    type: A.REQUEST_RESTORE_ITEM,
  };
};

const receiveRestoreItem = (data) => {
  return {
    type: A.RECEIVE_RESTORE_ITEM,
    data,
  };
};

const errorRestoreItem = (err) => {
  return {
    type: A.ERROR_RESTORE_ITEM,
    err,
  };
};

export const fetchHideShowItem = (item) => {
  return (dispatch, getState) => {
    dispatch(requestHideShowItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products',
        tokens: getState().auth.tokenData,
        body: item,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveHideShowItem(item));
            resolve(res.product);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorHideShowItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorHideShowItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestHideShowItem = () => {
  return {
    type: A.REQUEST_HIDESHOW_ITEM,
  };
};

const receiveHideShowItem = (data) => {
  return {
    type: A.RECEIVE_HIDESHOW_ITEM,
    data,
  };
};

const errorHideShowItem = (err) => {
  return {
    type: A.ERROR_HIDESHOW_ITEM,
    err,
  };
};

export const fetchGetFeatures = () => {
  return (dispatch, getState) => {
    dispatch(requestGetFeatures());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/products/features',
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetFeatures(res.features));
            resolve(res.features);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetFeatures(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetFeatures(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetFeatures = () => {
  return {
    type: A.REQUEST_GET_FEATURES,
  };
};

const receiveGetFeatures = (data) => {
  return {
    type: A.RECEIVE_GET_FEATURES,
    data,
  };
};

const errorGetFeatures = (err) => {
  return {
    type: A.ERROR_GET_FEATURES,
    err,
  };
};

export const fetchAddFeature = (data) => {
  return (dispatch, getState) => {
    dispatch(requestAddFeature());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/features',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddFeature());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddFeature(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddFeature(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddFeature = () => {
  return {
    type: A.REQUEST_ADD_FEATURE,
  };
};

const receiveAddFeature = (data) => {
  return {
    type: A.RECEIVE_ADD_FEATURE,
    data,
  };
};

const errorAddFeature = (err) => {
  return {
    type: A.ERROR_ADD_FEATURE,
    err,
  };
};

export const fetchGetAttributes = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAttributes());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/products/attributes',
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAttributes(res.attributes));
            resolve(res.attributes);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAttributes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAttributes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAttributes = () => {
  return {
    type: A.REQUEST_GET_ATTRIBUTES,
  };
};

const receiveGetAttributes = (data) => {
  return {
    type: A.RECEIVE_GET_ATTRIBUTES,
    data,
  };
};

const errorGetAttributes = (err) => {
  return {
    type: A.ERROR_GET_ATTRIBUTES,
    err,
  };
};

export const fetchAddAttribute = (data) => {
  return (dispatch, getState) => {
    dispatch(requestAddAttribute());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/attributes',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddAttribute());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddAttribute(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddAttribute(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddAttribute = () => {
  return {
    type: A.REQUEST_ADD_ATTRIBUTE,
  };
};

const receiveAddAttribute = (data) => {
  return {
    type: A.RECEIVE_ADD_ATTRIBUTE,
    data,
  };
};

const errorAddAttribute = (err) => {
  return {
    type: A.ERROR_ADD_ATTRIBUTE,
    err,
  };
};

export const fetchGetAdditionalDescs = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdditionalDescs());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/products/additional_descriptions/titles',
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAdditionalDescs(res.titles));
            resolve(res.titles);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAdditionalDescs(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAdditionalDescs(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAdditionalDescs = () => {
  return {
    type: A.REQUEST_GET_ADDITIONAL_DESCS,
  };
};

const receiveGetAdditionalDescs = (data) => {
  return {
    type: A.RECEIVE_GET_ADDITIONAL_DESCS,
    data,
  };
};

const errorGetAdditionalDescs = (err) => {
  return {
    type: A.ERROR_GET_ADDITIONAL_DESCS,
    err,
  };
};

export const fetchExportItems =
  (
    data, //TODO привести к единому формату
  ) =>
  (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/export/sku`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            reject(res);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };

export const fetchExportItemsToFulfillment = (data) => {
  return (dispatch, getState) => {
    dispatch(requestExportItemsToFulfillment());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/export_ff',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveExportItemsToFulfillment());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorExportItemsToFulfillment(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorExportItemsToFulfillment(err));
        },
      });
    });
  };
};

const requestExportItemsToFulfillment = () => {
  return {
    type: A.REQUEST_EXPORT_ITEMS_TO_FULFILLMENT,
  };
};

const receiveExportItemsToFulfillment = (data) => {
  return {
    type: A.RECEIVE_EXPORT_ITEMS_TO_FULFILLMENT,
    data,
  };
};

const errorExportItemsToFulfillment = (err) => {
  return {
    type: A.ERROR_EXPORT_ITEMS_TO_FULFILLMENT,
    err,
  };
};

export const fetchGetSubscriptionData = (productId) => {
  return (dispatch, getState) => {
    dispatch(requestGetSubscriptionData());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/product/subscription?id=' + productId,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSubscriptionData());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSubscriptionData(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSubscriptionData(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSubscriptionData = () => {
  return {
    type: A.REQUEST_GET_SUBSCRIPTION_DATA,
  };
};

const receiveGetSubscriptionData = (data) => {
  return {
    type: A.RECEIVE_GET_SUBSCRIPTION_DATA,
    data,
  };
};

const errorGetSubscriptionData = (err) => {
  return {
    type: A.ERROR_GET_SUBSCRIPTION_DATA,
    err,
  };
};

export const fetchGetProductAppearance = (productId) => {
  return (dispatch, getState) => {
    dispatch(requestGetProductAppearance());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/products/features/appearance?id=${productId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetProductAppearance(res.appearanceFields));
            resolve(res.appearanceFields);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetProductAppearance(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetProductAppearance(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProductAppearance = () => {
  return {
    type: A.REQUEST_GET_PRODUCT_APPEARANCE,
  };
};

const receiveGetProductAppearance = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCT_APPEARANCE,
    data,
  };
};

const errorGetProductAppearance = (err) => {
  return {
    type: A.ERROR_GET_PRODUCT_APPEARANCE,
    err,
  };
};

export const fetchUpdateProductAppearance = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateProductAppearance());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/products/features/appearance`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateProductAppearance());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateProductAppearance(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateProductAppearance(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateProductAppearance = () => {
  return {
    type: A.REQUEST_UPDATE_PRODUCT_APPEARANCE,
  };
};

const receiveUpdateProductAppearance = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PRODUCT_APPEARANCE,
    data,
  };
};

const errorUpdateProductAppearance = (err) => {
  return {
    type: A.ERROR_UPDATE_PRODUCT_APPEARANCE,
    err,
  };
};

export const fetchGetProductReviews = ({ page, size, status }) => {
  let url = HOST + `/api/lite/products/reviews?size=${size}`;
  if (page) url += `&page=${page}`;
  if (status) url += `&status=${status}`;

  return (dispatch, getState) => {
    dispatch(requestGetProductReviews());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetProductReviews(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetProductReviews(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetProductReviews(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProductReviews = () => {
  return {
    type: A.REQUEST_GET_PRODUCT_REVIEWS,
  };
};

const receiveGetProductReviews = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCT_REVIEWS,
    data,
  };
};

const errorGetProductReviews = (err) => {
  return {
    type: A.ERROR_GET_PRODUCT_REVIEWS,
    err,
  };
};

export const fetchUpdateProductReview = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateProductReview());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/products/reviews`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateProductReview());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateProductReview(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateProductReview(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateProductReview = () => {
  return {
    type: A.REQUEST_UPDATE_PRODUCT_REVIEW,
  };
};

const receiveUpdateProductReview = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PRODUCT_REVIEW,
    data,
  };
};

const errorUpdateProductReview = (err) => {
  return {
    type: A.ERROR_UPDATE_PRODUCT_REVIEW,
    err,
  };
};

export const fetchImportSubscriptionData = ({ file, productId, variantId }) => {
  const formData = new FormData();
  formData.append('file', file);
  if (productId) formData.append('productId', productId);
  if (variantId) formData.append('variantId', variantId);

  return (dispatch, getState) => {
    dispatch(requestImportSubscriptionData());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/product/subscription/parse',
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveImportSubscriptionData());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorImportSubscriptionData(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorImportSubscriptionData(err));
          reject(err);
        },
      });
    });
  };
};

const requestImportSubscriptionData = () => {
  return {
    type: A.REQUEST_IMPORT_SUBSCRIPTION_DATA,
  };
};

const receiveImportSubscriptionData = (data) => {
  return {
    type: A.RECEIVE_IMPORT_SUBSCRIPTION_DATA,
    data,
  };
};

const errorImportSubscriptionData = (err) => {
  return {
    type: A.ERROR_IMPORT_SUBSCRIPTION_DATA,
    err,
  };
};

export const fetchGetAccountingAttributes = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAccountingAttributes());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/products/accounting_attributes',
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAccountingAttributes(res.attributes));
            resolve(res.attributes);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAccountingAttributes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAccountingAttributes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAccountingAttributes = () => {
  return {
    type: A.REQUEST_GET_ACCOUNTING_ATTRIBUTES,
  };
};

const receiveGetAccountingAttributes = (data) => {
  return {
    type: A.RECEIVE_GET_ACCOUNTING_ATTRIBUTES,
    data,
  };
};

const errorGetAccountingAttributes = (err) => {
  return {
    type: A.ERROR_GET_ACCOUNTING_ATTRIBUTES,
    err,
  };
};

export const fetchAddAccountingAttribute = (data) => {
  return (dispatch, getState) => {
    dispatch(requestAddAccountingAttribute());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/accounting_attributes',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveAddAccountingAttribute(data));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorAddAccountingAttribute(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorAddAccountingAttribute(err));
          reject(err);
        },
      });
    });
  };
};

const requestAddAccountingAttribute = () => {
  return {
    type: A.REQUEST_ADD_ACCOUNTING_ATTRIBUTE,
  };
};

const receiveAddAccountingAttribute = (data) => {
  return {
    type: A.RECEIVE_ADD_ACCOUNTING_ATTRIBUTE,
    data,
  };
};

const errorAddAccountingAttribute = (err) => {
  return {
    type: A.ERROR_ADD_ACCOUNTING_ATTRIBUTE,
    err,
  };
};

export const fetchExportMovements = (id) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/export/sku/movements?id=${encodeId(id)}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetSKUSets = ({ id, warehouse, search, page, type }) => {
  let url = HOST + '/api/lite/products/sku_sets?size=10';
  if (id) url += `&id=${id}`;
  if (warehouse) url += `&warehouse=${warehouse}`;
  if (search) url += `&query=${search}`;
  if (page) url += `&page=${page}`;
  if (type) url += `&type=${type}`;

  return (dispatch, getState) => {
    dispatch(requestGetSKUSets());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSKUSets(res));

            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSKUSets(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSKUSets(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSKUSets = () => {
  return {
    type: A.REQUEST_GET_SKU_SETS,
  };
};

const receiveGetSKUSets = (data) => {
  return {
    type: A.RECEIVE_GET_SKU_SETS,
    data,
  };
};

const errorGetSKUSets = (err) => {
  return {
    type: A.ERROR_GET_SKU_SETS,
    err,
  };
};

export const fetchUpdateSKUSet = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateSKUSet());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/sku_sets',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateSKUSet(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateSKUSet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateSKUSet(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateSKUSet = () => {
  return {
    type: A.REQUEST_UPDATE_SKU_SET,
  };
};

const receiveUpdateSKUSet = (data) => {
  return {
    type: A.RECEIVE_UPDATE_SKU_SET,
    data,
  };
};

const errorUpdateSKUSet = (err) => {
  return {
    type: A.ERROR_UPDATE_SKU_SET,
    err,
  };
};

export const fetchGetPhysicalSetOrders = ({ search, page }) => {
  let url = HOST + '/api/lite/physical_set_orders?size=10';
  if (search) url += `&query=${search}`;
  if (page) url += `&page=${page}`;

  return (dispatch, getState) => {
    dispatch(requestGetPhysicalSetOrders());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPhysicalSetOrders(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPhysicalSetOrders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPhysicalSetOrders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPhysicalSetOrders = () => {
  return {
    type: A.REQUEST_GET_PHYSICAL_SET_ORDERS,
  };
};

const receiveGetPhysicalSetOrders = (data) => {
  return {
    type: A.RECEIVE_GET_PHYSICAL_SET_ORDERS,
    data,
  };
};

const errorGetPhysicalSetOrders = (err) => {
  return {
    type: A.ERROR_GET_PHYSICAL_SET_ORDERS,
    err,
  };
};

export const fetchUpdatePhysicalSetOrder = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdatePhysicalSetOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/physical_set_orders',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdatePhysicalSetOrder(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdatePhysicalSetOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdatePhysicalSetOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdatePhysicalSetOrder = () => {
  return {
    type: A.REQUEST_UPDATE_PHYSICAL_SET_ORDER,
  };
};

const receiveUpdatePhysicalSetOrder = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PHYSICAL_SET_ORDER,
    data,
  };
};

const errorUpdatePhysicalSetOrder = (err) => {
  return {
    type: A.ERROR_UPDATE_PHYSICAL_SET_ORDER,
    err,
  };
};

export const fetchCopyPhysicalSetOrder = (data) => {
  return (dispatch, getState) => {
    dispatch(requestCopyPhysicalSetOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/physical_set_orders/copy',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveCopyPhysicalSetOrder(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCopyPhysicalSetOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCopyPhysicalSetOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestCopyPhysicalSetOrder = () => {
  return {
    type: A.REQUEST_COPY_PHYSICAL_SET_ORDER,
  };
};

const receiveCopyPhysicalSetOrder = (data) => {
  return {
    type: A.RECEIVE_COPY_PHYSICAL_SET_ORDER,
    data,
  };
};

const errorCopyPhysicalSetOrder = (err) => {
  return {
    type: A.ERROR_COPY_PHYSICAL_SET_ORDER,
    err,
  };
};

export const fetchCancelPhysicalSetOrder = (data) => {
  return (dispatch, getState) => {
    dispatch(requestCancelPhysicalSetOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/physical_set_orders/cancel',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveCancelPhysicalSetOrder(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCancelPhysicalSetOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCancelPhysicalSetOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestCancelPhysicalSetOrder = () => {
  return {
    type: A.REQUEST_CANCEL_PHYSICAL_SET_ORDER,
  };
};

const receiveCancelPhysicalSetOrder = (data) => {
  return {
    type: A.RECEIVE_CANCEL_PHYSICAL_SET_ORDER,
    data,
  };
};

const errorCancelPhysicalSetOrder = (err) => {
  return {
    type: A.ERROR_CANCEL_PHYSICAL_SET_ORDER,
    err,
  };
};

export const fetchGetWBCategories = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/products/wb_categories`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetEshops = (data) => {
  return (dispatch, getState) => {
    dispatch(requestGetEshops());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + '/api/lite/eshops/for_mapping',
        tokens: getState().auth.tokenData,
        callback: (res) => {
          dispatch(receiveGetEshops(res));
          resolve(res);
        },
        error: (err) => {
          dispatch(errorGetEshops(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshops = () => {
  return {
    type: A.REQUEST_GET_ESHOPS,
  };
};

const receiveGetEshops = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOPS,
    data,
  };
};

const errorGetEshops = (err) => {
  return {
    type: A.ERROR_GET_ESHOPS,
    err,
  };
};

export const fetchGetProductsHistory = ({ productId, page, size, id }) => {
  let url = HOST + '/api/lite/products/history?';
  if (size) url += `size=${size}&`;
  if (page) url += `page=${page}&`;
  if (productId) url += `productId=${encodeId(productId)}&`;
  if (id) url += `id=${id}&`;

  url = url.slice(0, url.length - 1);

  return (dispatch, getState) => {
    dispatch(requestGetProductsHistory());
    return new Promise((resolve, reject) => {
      apiGet({
        url: url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          dispatch(receiveGetProductsHistory(res));
          resolve(res);
        },
        error: (err) => {
          dispatch(errorGetProductsHistory(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProductsHistory = () => {
  return {
    type: A.REQUEST_GET_PRODUCTS_HISTORY,
  };
};

const receiveGetProductsHistory = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCTS_HISTORY,
    data,
  };
};

const errorGetProductsHistory = (err) => {
  return {
    type: A.ERROR_GET_PRODUCTS_HISTORY,
    err,
  };
};

export const fetchProductsHistoryDiff = (data) => {
  return (dispatch, getState) => {
    dispatch(requestFetchProductsHistoryDiff());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/history/diff',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFetchProductsHistoryDiff(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFetchProductsHistoryDiff(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFetchProductsHistoryDiff(err));
          reject(err);
        },
      });
    });
  };
};

const requestFetchProductsHistoryDiff = () => {
  return {
    type: A.REQUEST_PRODUCTS_HISTORY_DIFF,
  };
};

const receiveFetchProductsHistoryDiff = (data) => {
  return {
    type: A.RECEIVE_PRODUCTS_HISTORY_DIFF,
    data,
  };
};

const errorFetchProductsHistoryDiff = (err) => {
  return {
    type: A.ERROR_PRODUCTS_HISTORY_DIFF,
    err,
  };
};

export const fetchProductsBatchAccountingStocks = ({ warehouseCode, variantId, isXls = false }) => {
  if (!warehouseCode) {
    console.error('warehouseCode is required');
    return;
  }
  let url = `${HOST}/api/lite/products/batch/accounting/stocks`;
  let params = `?warehouseCode=${warehouseCode}&format=${isXls ? 'xls' : 'json'}`;
  if (variantId) {
    let arrVariantId = !Array.isArray(variantId) ? [variantId] : variantId;
    if (arrVariantId?.length) {
      params += `&variantId=${arrVariantId.join(',')}`;
    }
  }
  return (dispatch, getState) => {
    dispatch(requestFetchProductsBatchAccountingStocks());
    return new Promise((resolve, reject) => {
      apiGet({
        url: url + params,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFetchProductsBatchAccountingStocks(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFetchProductsBatchAccountingStocks(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFetchProductsBatchAccountingStocks(err));
          reject(err);
        },
      });
    });
  };
};

const requestFetchProductsBatchAccountingStocks = () => {
  return {
    type: A.REQUEST_PRODUCTS_BATCH_ACCOUNTING_STOCKS,
  };
};

const receiveFetchProductsBatchAccountingStocks = (data) => {
  return {
    type: A.RECEIVE_PRODUCTS_BATCH_ACCOUNTING_STOCKS,
    data,
  };
};

const errorFetchProductsBatchAccountingStocks = (err) => {
  return {
    type: A.ERROR_PRODUCTS_BATCH_ACCOUNTING_STOCKS,
    err,
  };
};

export const fetchProductsWarehouseCategories = () => {
  let url = `${HOST}/api/lite/products/warehouse/categories`;
  return (dispatch, getState) => {
    dispatch(requestProductsWarehouseCategories());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveProductsWarehouseCategories(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorProductsWarehouseCategories(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorProductsWarehouseCategories(err));
          reject(err);
        },
      });
    });
  };
};

const requestProductsWarehouseCategories = () => {
  return {
    type: A.REQUEST_PRODUCTS_WAREHOUSE_CATEGORIES,
  };
};

const receiveProductsWarehouseCategories = (data) => {
  return {
    type: A.RECEIVE_PRODUCTS_WAREHOUSE_CATEGORIES,
    data,
  };
};

const errorProductsWarehouseCategories = (err) => {
  return {
    type: A.ERROR_PRODUCTS_WAREHOUSE_CATEGORIES,
    err,
  };
};

export const fetchGetProductsPriceMarginHistory = (variantId) => {
  let url = `${HOST}/api/lite/products/prices/margin/history?id=${variantId}`;
  return (dispatch, getState) => {
    dispatch(requestGetProductsPriceMarginHistory());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetProductsPriceMarginHistory(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetProductsPriceMarginHistory(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetProductsPriceMarginHistory(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProductsPriceMarginHistory = () => {
  return {
    type: A.REQUEST_GET_PRODUCTS_PRICE_MARGIN_HISTORY,
  };
};

const receiveGetProductsPriceMarginHistory = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCTS_PRICE_MARGIN_HISTORY,
    data,
  };
};

export const resetGetProductsPriceMarginHistory = () => {
  const emptyData = [];
  return {
    type: A.RESET_GET_PRODUCT_PRICE_MARGIN_HISTORY,
    emptyData,
  };
};

const errorGetProductsPriceMarginHistory = (err) => {
  return {
    type: A.ERROR_GET_PRODUCTS_PRICE_MARGIN_HISTORY,
    err,
  };
};

export const fetchGetProductMargin = (id, isDelivered) => {
  return (dispatch, getState) => {
    dispatch(requestGetProductMargin());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/products/margin?id=${id}&isDelivered=${isDelivered}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (isDelivered && res.date) {
            dispatch(receiveGetProductMarginDelivered(res)); //Доставленные
            resolve(res);
          } else if (!isDelivered && res.date) {
            dispatch(receiveGetProductMarginShipped(res)); //Отгруженные
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetProductMargin(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetProductMargin(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProductMargin = () => {
  return {
    type: A.REQUEST_GET_PRODUCT_MARGIN,
  };
};

const receiveGetProductMarginDelivered = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCT_MARGIN_DELIVERED,
    data,
  };
};

const receiveGetProductMarginShipped = (data) => {
  return {
    type: A.RECEIVE_GET_PRODUCT_MARGIN_SHIPPED,
    data,
  };
};

export const resetGetProductMargin = () => {
  const emptyData = [];
  return {
    type: A.RESET_GET_PRODUCT_MARGIN,
    emptyData,
  };
};

const errorGetProductMargin = (err) => {
  return {
    type: A.ERROR_GET_PRODUCT_MARGIN,
    err,
  };
};

export const fetchImportChestnyznakUniqNumbersExcel = (file, variantId, fileType) => {
  const formData = new FormData();
  formData.append('upfile', file);

  if (variantId) formData.append('id', variantId);

  return (dispatch, getState) => {
    dispatch(requestImportChestnyznakUniqNumbersExcel());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/products/load/unique_number/${fileType}`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveImportChestnyznakUniqNumbersExcel());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorImportChestnyznakUniqNumbersExcel(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorImportChestnyznakUniqNumbersExcel(err));
          reject(err);
        },
      });
    });
  };
};

const requestImportChestnyznakUniqNumbersExcel = () => {
  return {
    type: A.REQUEST_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL,
  };
};

const receiveImportChestnyznakUniqNumbersExcel = (data) => {
  return {
    type: A.RECEIVE_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL,
    data,
  };
};

const errorImportChestnyznakUniqNumbersExcel = (err) => {
  return {
    type: A.ERROR_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL,
    err,
  };
};

export const fetchStatisticsOfUsingChestnyznak = (arrOfVariantIds) => {
  return (dispatch, getState) => {
    dispatch(requestStatisticsOfUsingChestnyznak());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/products/sku/serial-number/info',
        tokens: getState().auth.tokenData,
        body: arrOfVariantIds,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveStatisticsOfUsingChestnyznak(res.skus));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorStatisticsOfUsingChestnyznak(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorStatisticsOfUsingChestnyznak(err));
          reject(err);
        },
      });
    });
  };
};

const requestStatisticsOfUsingChestnyznak = () => {
  return {
    type: A.REQUEST_STATISTICS_OF_USING_CHESTNYZNAK,
  };
};

const receiveStatisticsOfUsingChestnyznak = (data) => {
  return {
    type: A.RECEIVE_STATISTICS_OF_USING_CHESTNYZNAK,
    data,
  };
};

const errorStatisticsOfUsingChestnyznak = (err) => {
  return {
    type: A.ERROR_STATISTICS_OF_USING_CHESTNYZNAK,
    err,
  };
};

export const fetchUnloadingSetOfGoodsChestnyznak = (id) => {
  let url = HOST + `/api/lite/physical_set_orders/export/excel?id=${id}`;
  return (dispatch, getState) => {
    dispatch(requestUnloadingSetOfGoodsChestnyznak());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success === true) {
            dispatch(receiveUnloadingSetOfGoodsChestnyznak(res));
            resolve(res);
          }
          if (res.success === false) {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors[0].message);
            dispatch(errorUnloadingSetOfGoodsChestnyznak(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUnloadingSetOfGoodsChestnyznak(err));
          reject(err);
        },
      });
    });
  };
};

const requestUnloadingSetOfGoodsChestnyznak = () => {
  return {
    type: A.REQUEST_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK,
  };
};

const receiveUnloadingSetOfGoodsChestnyznak = (data) => {
  return {
    type: A.RECEIVE_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK,
    data,
  };
};

const errorUnloadingSetOfGoodsChestnyznak = (err) => {
  return {
    type: A.ERROR_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK,
    err,
  };
};

export const fetchGetStockByDate = (data) => {
  return (dispatch, getState) => {
    const url = HOST + `/api/lite/products/stocks/by/date?stock_date=${data}`;
    dispatch(requestGetStockByDate());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetStockByDate(res));
            resolve(res);
          }
          if (res.errors) {
            const err = { data: { errors: res.errors } };
            dispatch(receiveGetStockByDate(err));
            toast.error(data.errors[0].message || 'Ошибка при экспорте остатков!');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetStockByDate(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetStockByDate = () => {
  return {
    type: A.REQUEST_GET_STOCK_BY_DATE,
  };
};

const receiveGetStockByDate = (data) => {
  return {
    type: A.RECEIVE_GET_STOCK_BY_DATE,
    data,
  };
};

const errorGetStockByDate = (err) => {
  return {
    type: A.ERROR_GET_STOCK_BY_DATE,
    err,
  };
};

export const fetchGetCommonMaterial = (data) => {
  return (dispatch, getState) => {
    const url = HOST + `/api/lite/products/packing/materials/common?size=${data.size}`;
    dispatch(requestGetCommonMaterial());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetCommonMaterial(res));
            resolve(res);
          }
          if (res.errors) {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCommonMaterial(err));
            toast.error(data.errors[0].message || 'Ошибка при получении данных!');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCommonMaterial(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCommonMaterial = () => {
  return {
    type: A.REQUEST_GET_COMMON_MATERIAL,
  };
};

const receiveGetCommonMaterial = (data) => {
  return {
    type: A.RECEIVE_GET_COMMON_MATERIAL,
    data,
  };
};

const errorGetCommonMaterial = (err) => {
  return {
    type: A.ERROR_GET_COMMON_MATERIAL,
    err,
  };
};

export const fetchGetPackagingShipmentReport = (dateFrom, dateTo) => {
  const data = null;
  return (dispatch, getState) => {
    const url =
      HOST +
      `/api/lite/products/packing_materials/stocks/by/date?date_from=${dateFrom}&date_to=${dateTo}`;
    dispatch(requestGetPackagingShipmentReport());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPackagingShipmentReport(res));
            resolve(res);
          }
          if (res.errors) {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPackagingShipmentReport(err));
            toast.error(res.errors[0].message || 'Ошибка при получении данных!');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPackagingShipmentReport(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPackagingShipmentReport = () => {
  return {
    type: A.REQUEST_GET_PACKAGING_SHIPMENT_REPORT,
  };
};

const receiveGetPackagingShipmentReport = (data) => {
  return {
    type: A.RECEIVE_GET_PACKAGING_SHIPMENT_REPORT,
    data,
  };
};

const errorGetPackagingShipmentReport = (err) => {
  return {
    type: A.ERROR_GET_PACKAGING_SHIPMENT_REPORT,
    err,
  };
};

export const toggleMonoBoxesVisibilityAction = (data) => {
  return {
    type: A.TOGGLE_MONOBOXES_VISIBILITY,
    data,
  };
};

export const fetchUploadStickerPalletsExcel = (formData) => {
  return (dispatch, getState) => {
    dispatch(requestFetchUploadStickerPalletsExcel());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/packing/fbm/sticker/pallets/xls`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFetchUploadStickerPalletsExcel(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFetchUploadStickerPalletsExcel(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFetchUploadStickerPalletsExcel(err));
          reject(err);
        },
      });
    });
  };
};

const requestFetchUploadStickerPalletsExcel = () => {
  return {
    type: A.REQUEST_UPLOAD_STICKERS_PALLET_EXCEL,
  };
};

const receiveFetchUploadStickerPalletsExcel = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_STICKERS_PALLET_EXCEL,
    data,
  };
};

const errorFetchUploadStickerPalletsExcel = (err) => {
  return {
    type: A.ERROR_UPLOAD_STICKERS_PALLET_EXCEL,
    err,
  };
};
